// @ts-nocheck
import React, { useRef, useState } from "react";
import {useIdleTimer} from 'react-idle-timer'
import SessionTimeoutDialog from "./SessionTimeoutDialog";
let countdownInterval:any;
let timeout:any;
const SessionTimeout = ({isAuthenticated, logOut}) => {
const [timeoutModalOpen, setTimeoutModalOpen] = useState(false);
const [timeoutCountdown, setTimeoutCountdown] = useState(0);
const idleTimeRef = useRef(null);
const clearSessionTimeout = () => {
clearTimeout(timeout);
};
const clearSessionInterval = () => {
clearInterval(countdownInterval);
};
const handleLogout = async (isTimedOut = false) => {
try {
setTimeoutModalOpen(false);
clearSessionInterval();
clearSessionTimeout();
logOut();
} catch (err) {
console.error(err);
}
};
const handleContinue = () => {
setTimeoutModalOpen(false);
clearSessionInterval();
clearSessionTimeout();
};
const onActive = () => {
if (!timeoutModalOpen) {
clearSessionInterval();
clearSessionTimeout();
}
};
const onIdle = () => {
const delay = 1000 * 1;
if (isAuthenticated && !timeoutModalOpen) {
timeout = setTimeout(() => {
let countDown = 10;
setTimeoutModalOpen(true);
setTimeoutCountdown(countDown);
countdownInterval = setInterval(() => {
if (countDown > 0) {
setTimeoutCountdown(--countDown);
} else {
handleLogout(true);
}
}, 1000);
}, delay);
}
};
const idleTimer = useIdleTimer({
    crossTab: true,
    ref: idleTimeRef,
    timeout: 15 * 60 * 1000,
    onIdle: onIdle,
  });
return (
<>
<div idletimer={idleTimer}/>
<SessionTimeoutDialog
countdown={timeoutCountdown}
onContinue={handleContinue}
onLogout={() => handleLogout(false)}
open={timeoutModalOpen}
/>
</>
);
}
export default SessionTimeout;